import { render } from "./FinTransaccion.vue?vue&type=template&id=71972087"
import script from "./FinTransaccion.vue?vue&type=script&lang=js"
export * from "./FinTransaccion.vue?vue&type=script&lang=js"

import "./FinTransaccion.vue?vue&type=style&index=0&id=71972087&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__